import React, { Fragment, useEffect, useReducer } from "react";
import { Row, Col } from "react-bootstrap";
import { Currency } from "../lib/components/Currency";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { FormattedDate } from "../lib/components/FormattedDate";
import { Address } from "../lib/components/Address";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { useParams } from "react-router-dom";
import "./clearpoint-reports.css";

const SocialSecurityLetterPrint = (props) => {
  const initialState = {
    isLoading: true,
    contract: {
      provider: {
        address: {},
      },
      purchaser: {
        address: {},
      },
      recipients: [],
      benficiaries: [],
    },
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "contractDetails":
        return {
          ...state,
          contract: action.payload,
          isLoading: false,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      case "hideLoader":
        return {
          ...state,
          isLoading: false,
        };
      default:
        throw new Error();
    }
  };

  const [socialSecurityLetterState, dispatch] = useReducer(
    reducer,
    initialState,
  );
  const { number } = useParams();

  useEffect(() => {
    async function getContractDetails() {
      props.header.setHeader("socialSecurityLetterPrint");
      await props.api
        .get(`/api/contract/${number}`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "contractDetails", payload: data });
        })
        .catch(hideLoader)
        .then(hideLoader);
    }
    getContractDetails();
  }, []);

  const hideLoader = () => {
    dispatch({ type: "hideLoader" });
  };

  const getCurrentDate = () => {
    const currentDate = new Date();
    return <FormattedDate date={currentDate} format="M/D/YYYY" />;
  };

  if (socialSecurityLetterState.isLoading) {
    return <LoadingSpinner />;
  }

  const { contract } = socialSecurityLetterState;
  const recipients = contract.recipients
    .map((rec) => `${rec.firstName} ${rec.lastName}`)
    .join(", ");
  const beneficiaries = contract.beneficiaries
    .map((rec) => `${rec.firstName} ${rec.lastName}`)
    .join(", ");
  const providerType =
    contract.provider && contract.provider.providerType === 1
      ? "Funeral"
      : "Cemetery";

  const isIrrevocable = contract.irrevocable ? "IRREVOCABLE" : "REVOCABLE";
  var customLogo = contract?.provider?.providerLogo;

  return (
    <Fragment className="ssi-letter">
      <Row>
        <Row>
          {customLogo ? (
            <Col xs={12} className="logo-container">
              <div className="receipt-header__inner justify-content-center">
                <div className="receipt-header__logo-wrap">
                  <img
                    src={`data:${customLogo.contentType};base64,${customLogo.logoBase64}`}
                    alt="Customer logo"
                    className="receipt-header__logo__bigger"
                  />
                </div>
              </div>
            </Col>
          ) : (
            <Col xs={12} style={{ textAlign: "center" }}>
              <img
                src="/images/Clearpoint_Confirmation_Receipt_Logo.png"
                alt="header"
                className="confirmation-img"
              />
            </Col>
          )}
        </Row>
        <Col xs={11}>
          <Row className="ssi-letter-headings">
            <Col>
              <div>{getCurrentDate()}</div>
            </Col>
          </Row>
          <Row className="ssi-letter-headings">
            <Col>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}
                <br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              Trust Number: {contract.number}
              <br />
            </Col>
          </Row>
          <Row className="ssi-letter-p">
            <Col>
              <div>
                The following information describes the current status of{" "}
                {recipients} preneed {providerType.toLowerCase()} trust with
                ClearPoint Federal Bank & Trust, which was purchased to fund a{" "}
                {providerType.toLowerCase()} plan with:{" "}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <div>{contract.provider.name}</div>
            </Col>
          </Row>
          <Row>
            <Col className="ssi-letter-p">
              <div>We are sending this data to you at your request.</div>
            </Col>
          </Row>
          <Row>
            <Col className="ssi-letter-p">
              <div>
                <label>Confirmation of the trust.</label>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className="ssi-letter-info">
            <Col>
              {providerType} Recipient: {recipients}
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              {providerType} Purchaser: {contract.purchaser.firstName}{" "}
              {contract.purchaser.lastName}
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              Beneficiary: {beneficiaries || `The Estate of ${recipients}`}
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              Accepted Date:{" "}
              <FormattedDate date={contract.accepted} format="M/D/YYYY" />
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              {providerType} Plan Amount:{" "}
              <Currency amount={contract.netPrice} />
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              Amount Paid: <Currency amount={contract.paid} />
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>
              Market Value: <Currency amount={contract.value} />
            </Col>
          </Row>
          <Row className="ssi-letter-info">
            <Col>This contract is {isIrrevocable}</Col>
          </Row>
        </Col>
      </Row>
      <Row className="ssi-letter-p">
        <p>
          Should you have any questions regarding the contents of this letter,
          please contact our Customer Service Department at 1-800-763-0234.
        </p>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="ssi-letter-p">
            <div>Sincerely,</div>
            <div style={{ marginTop: ".3in" }}>
              ClearPoint Federal Bank & Trust
            </div>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

export default withHeaderMessages(WithApiAccess(SocialSecurityLetterPrint));
